import bok3 from "../../../assets/images/Suitable/bok3.svg";
import tickwwhite from "../../../assets/images/Suitable/tickwwhite.svg";
import right from "../../../assets/images/Suitable/right.svg";
import right2 from "../../../assets/images/Suitable/right2.svg";
import tick23 from "../../../assets/images/Suitable/tick23.svg";
import bomath from "../../../assets/images/Suitable/bomath.svg";
import blur from "../../../assets/images/Suitable/blur.svg";
import teacher from "../../../assets/images/Suitable/teacher.svg";
import school from "../../../assets/images/Suitable/school.svg";
import award from "../../../assets/images/Suitable/award.svg";
import ButtonDKN from "src/component/Button/ButtonDKN";
export default function SolutionSuitable() {
  return (
    <div className="mt-10 w-full mx-auto container px-[20px] py-[20px] flex flex-col gap-3">
      <div className="text-center text-[#053CC8] md:text-[32px] text-[24px] font-semibold">
        BLUERISE PHÙ HỢP VỚI
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 items-center md:gap-6">
        <div className="w-full flex flex-col gap-7 md:gap-5 h-[600px] border text-white border-[#E6ECFA] rounded-[8px] px-[24px] py-[24px] bg-puc ">
          <div className="w-10 h-10 px-[6px] py-[6px] bg-white rounded-[8px] flex items-center justify-center">
            <img src={bok3} alt="bok3" />
          </div>
          <div className="text-[20px] md:text-[24px] font-medium">
            Trung tâm ngoại ngữ
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tickwwhite} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Giải pháp tối ưu cho trung tâm ngoại ngữ hiện đại.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tickwwhite} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Bài tập số hóa 4 kỹ năng (Nghe - Nói - Đọc - Viết) chuẩn theo
                tiêu chuẩn của tổ chức khảo thí
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tickwwhite} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Giao diện song ngữ hỗ trợ giáo viên nước ngoài thao tác mượt mà.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tickwwhite} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Quản lý lớp học, học viên, lộ trình học tập chi tiết trên cùng
                một nền tảng.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex  gap-2 h-[48px]">
              <div className="flex-shrink-0 mr-2">
                <img src={right} alt="tw" />
              </div>
              <div className="text-[16px] font-medium">
                Tối ưu vận hành - Chuẩn hóa giảng dạy - Bùng nổ trải nghiệm học
                viên.
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-0 text-[#606060]">
            <ButtonDKN
              txt="Tìm hiểu thêm"
              cl="bg-white !text-[#053CC8] rounded-[8px] hover:bg-slate-200"
            />
          </div>
        </div>
        <div className="w-full flex flex-col gap-7 md:gap-5 h-[600px] border-2 border-solid text-[#606060] shadow-custom-light3 border-[#E2E2E2] rounded-[8px] px-[24px] py-[24px] bg-white ">
          <div className="w-10 h-10 px-[6px] py-[6px] bg-[#FFF8EA] rounded-[8px]  flex items-center justify-center">
            <img src={bomath} alt="bok3" />
          </div>
          <div className="text-[20px] md:text-[24px] font-medium">
            Trung tâm Toán
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Giải pháp chuyên biệt cho trung tâm Toán tư duy và kỹ năng.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                PC App chuyên dụng cho dạy Toán online cực kỳ trực quan và hiệu
                quả.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Bộ công cụ giảng dạy đầy đủ: bảng đen, thước đo góc, compa, bút
                highlight...
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Quản lý lớp học, giáo viên, học viên một cách khoa học và linh
                hoạt.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex  gap-2 h-[48px]">
              <div className="flex-shrink-0 mr-2">
                <img src={right} alt="tw" />
              </div>
              <div className="text-[16px] font-medium">
                Dạy Toán chuẩn mực - Quản lý dễ dàng - Tối ưu hiệu quả đào tạo.
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-0">
            <ButtonDKN
              txt="Tìm hiểu thêm"
              cl="bg-puc !text-white rounded-[8px] hover:bg-pa"
            />
          </div>
        </div>
        <div className="w-full flex flex-col gap-7 md:gap-5 h-[600px] border-2 border-solid text-[#606060] shadow-custom-light3 border-[#E2E2E2] rounded-[8px] px-[24px] py-[24px] bg-white ">
          <div className="w-10 h-10 px-[6px] py-[6px] bg-[#EAF8E8] rounded-[8px]  flex items-center justify-center">
            <img src={blur} alt="bok3" />
          </div>
          <div className="text-[20px] md:text-[24px] font-medium">
            Trung tâm Kỹ năng sống
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Nâng tầm quản lý trung tâm kỹ năng sống bằng công nghệ.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Mobile App đồng bộ giúp phụ huynh theo sát quá trình phát triển
                của con.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Theo dõi tiến độ học tập, báo cáo kết quả chi tiết từng kỹ năng.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Linh hoạt tổ chức các hoạt động ngoại khóa, workshop, chương
                trình kỹ năng.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex  gap-2 h-[48px]">
              <div className="flex-shrink-0 mr-2">
                <img src={right} alt="tw" />
              </div>
              <div className="text-[16px] font-medium">
                Kết nối phụ huynh - Nâng cao giá trị đào tạo - Xây dựng thương
                hiệu bền vững.
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-2">
            <ButtonDKN
              txt="Tìm hiểu thêm"
              cl="bg-puc !text-white rounded-[8px] hover:bg-pa"
            />
          </div>
        </div>
        <div className="w-full flex flex-col gap-7 md:gap-5 h-[600px] border-2 border-solid text-[#606060] shadow-custom-light3 border-[#E2E2E2] rounded-[8px] px-[24px] py-[24px] bg-white ">
          <div className="w-10 h-10 px-[6px] py-[6px] bg-[#FBEAEA] rounded-[8px]  flex items-center justify-center">
            <img src={teacher} alt="bok3" />
          </div>
          <div className="text-[20px] md:text-[24px] font-medium">
            Trung tâm Gia sư
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Giải pháp quản lý toàn diện cho trung tâm gia sư chuyên nghiệp.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Quản lý giáo viên, học sinh, lịch dạy, lịch nghỉ bù, dạy bù dễ
                dàng.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Tự động thống kê giờ dạy, hỗ trợ tính lương chính xác cho gia
                sư.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Tối ưu vận hành - Tiết kiệm thời gian - Minh bạch chi phí
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex  gap-2 h-[48px]">
              <div className="flex-shrink-0 mr-2">
                <img src={right} alt="tw" />
              </div>
              <div className="text-[16px] font-medium">
                Quản lý chặt chẽ - Tăng trưởng bền vững - chuyên nghiệp hóa dịch
                vụ.
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-0">
            <ButtonDKN
              txt="Tìm hiểu thêm"
              cl="bg-puc !text-white rounded-[8px] hover:bg-pa"
            />
          </div>
        </div>
        <div className="w-full flex flex-col gap-7 md:gap-5 h-[600px] border-2 border-solid text-[#606060] shadow-custom-light3 border-[#E2E2E2] rounded-[8px] px-[24px] py-[24px] bg-white ">
          <div className="w-10 h-10 px-[6px] py-[6px] bg-[#F5F2FF] rounded-[8px]  flex items-center justify-center">
            <img src={school} alt="bok3" />
          </div>
          <div className="text-[20px] md:text-[24px] font-medium">
            Trường học
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Chuyển đổi số toàn diện cho mô hình học hiện đại.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Quản lý học sinh, giáo viên, nhân sự, tài chính trên cùng một
                nền tảng.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Hệ thống hóa quản sinh, giảng dạy, hồ sơ học tập, tuyển sinh
                đồng bộ.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex items-center gap-2 h-[48px]">
              <div className="w-[24px] h-[24px] px-[2px] py-[2px] flex-shrink-0 mr-2 rounded-full">
                <img src={tick23} alt="tw" />
              </div>
              <div className="text-[16px] font-normal">
                Nâng cao hiệu suất vận hành, tối ưu hóa chi phí quản lý đào tạo
                cho toàn trường học.
              </div>
            </div>
          </div>
          <div>
            <div className="w-full flex  gap-2 h-[48px]">
              <div className="flex-shrink-0 mr-2">
                <img src={right} alt="tw" />
              </div>
              <div className="text-[16px] font-medium">
                Chuyển đổi số thông minh - hiện đại hóa vận hành - Nâng tầm chất
                lượng giáo dục.
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-2">
            <ButtonDKN
              txt="Tìm hiểu thêm"
              cl="bg-puc !text-white rounded-[8px] hover:bg-pa"
            />
          </div>
        </div>
        <div className="w-full flex flex-col justify-center items-center gap-5 h-[600px] border-2 border-solid text-[#606060] shadow-custom-light3 border-[#E2E2E2] rounded-[8px] bg-white">
          <div className="flex items-center w-full justify-center gap-2 py-[16px] bg-[#3763D3]">
            <img src={award} alt="aw" />
            <div className="text-white">Case Study</div>
          </div>
          <a href="/case-study" target="_blank">
            <div className="flex items-center justify-center gap-2">
              <div className="text-[16px] text-[#053CC8] font-semibold hover:text-blue-400">
                Tìm hiểu thêm
              </div>
              <img src={right2} alt="rw" />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
